export default (element) => {
  const menuListButtons = element.querySelectorAll('[data-footer-menu-list-title]');
  const skipToMain = document.querySelector('#skip_to_main');

  const getPanel = (btn) => {
    const id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  };

  const getChevron = (btn) => btn.querySelector('[data-footer-chevron]');

  const openPanel = (btn, panelEl, chevron) => {
    const panel = panelEl;
    btn.setAttribute('aria-expanded', 'true');
    if (panel) {
      panel.hidden = false;
      panel.classList.remove('hidden');
    }
    if (chevron) chevron.classList.add('rotate-180');
  };

  const closePanel = (btn, panelEl, chevron) => {
    const panel = panelEl;
    btn.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.hidden = true;
      panel.classList.add('hidden');
    }
    if (chevron) chevron.classList.remove('rotate-180');
  };

  const syncForViewport = () => {
    menuListButtons.forEach((btn) => {
      const panel = getPanel(btn);
      const chev = getChevron(btn);
      if (!panel) return;
      closePanel(btn, panel, chev);
    });
  };

  const menuLinkToggle = () => {
    menuListButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = getPanel(btn);
        const chev = getChevron(btn);
        if (!panel) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closePanel(btn, panel, chev);
        } else {
          openPanel(btn, panel, chev);
        }
      });
    });
  };

  const focusManagement = () => {
    const footerLinks = element.querySelectorAll('a');
    const lastFooterLink = footerLinks[footerLinks.length - 1];
    if (!lastFooterLink || !skipToMain) return;

    lastFooterLink.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        skipToMain.focus();
      }
    });
  };

  const init = () => {
    syncForViewport(); 
    menuLinkToggle();
    focusManagement();
  };

  init();
};